/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstUserOutput
 */
export interface MstUserOutput {
    /**
     * 
     * @type {number}
     * @memberof MstUserOutput
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof MstUserOutput
     */
    companyName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserOutput
     */
    companyHojinNo: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserOutput
     */
    companyAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserOutput
     */
    companyGln: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserOutput
     */
    businessCategory: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserOutput
     */
    tenantId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserOutput
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof MstUserOutput
     */
    userMail: string;
    /**
     * 
     * @type {string}
     * @memberof MstUserOutput
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof MstUserOutput
     */
    authType: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserOutput
     */
    authTypeName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstUserOutput
     */
    enabled: boolean;
    /**
     * 
     * @type {Date}
     * @memberof MstUserOutput
     */
    updateDatetime: Date | null;
}

/**
 * Check if a given object implements the MstUserOutput interface.
 */
export function instanceOfMstUserOutput(value: object): value is MstUserOutput {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('companyHojinNo' in value) || value['companyHojinNo'] === undefined) return false;
    if (!('companyAddress' in value) || value['companyAddress'] === undefined) return false;
    if (!('companyGln' in value) || value['companyGln'] === undefined) return false;
    if (!('businessCategory' in value) || value['businessCategory'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userMail' in value) || value['userMail'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('authType' in value) || value['authType'] === undefined) return false;
    if (!('authTypeName' in value) || value['authTypeName'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    return true;
}

export function MstUserOutputFromJSON(json: any): MstUserOutput {
    return MstUserOutputFromJSONTyped(json, false);
}

export function MstUserOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstUserOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'companyName': json['company_name'],
        'companyHojinNo': json['company_hojin_no'],
        'companyAddress': json['company_address'],
        'companyGln': json['company_gln'],
        'businessCategory': json['business_category'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
        'userMail': json['user_mail'],
        'userName': json['user_name'],
        'authType': json['auth_type'],
        'authTypeName': json['auth_type_name'],
        'enabled': json['enabled'],
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
    };
}

export function MstUserOutputToJSON(json: any): MstUserOutput {
    return MstUserOutputToJSONTyped(json, false);
}

export function MstUserOutputToJSONTyped(value?: MstUserOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'company_name': value['companyName'],
        'company_hojin_no': value['companyHojinNo'],
        'company_address': value['companyAddress'],
        'company_gln': value['companyGln'],
        'business_category': value['businessCategory'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
        'user_mail': value['userMail'],
        'user_name': value['userName'],
        'auth_type': value['authType'],
        'auth_type_name': value['authTypeName'],
        'enabled': value['enabled'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
    };
}

